module.exports = __webpack_public_path__ + "img/vino3d.b8eb6a78.jpg";